const TRACE_ID_PREFIX = "fp_lookup";

export function createLookupTraceId(): string {
  const cryptoApi = globalThis.crypto;
  if (cryptoApi && typeof cryptoApi.randomUUID === "function") {
    return cryptoApi.randomUUID();
  }

  return `${TRACE_ID_PREFIX}_${Date.now().toString(36)}_${Math.random()
    .toString(36)
    .slice(2, 10)}`;
}

export function nowMs(): number {
  if (typeof performance !== "undefined" && typeof performance.now === "function") {
    return performance.now();
  }

  return Date.now();
}

export function elapsedMs(startMs: number): number {
  return Math.max(0, Math.round(nowMs() - startMs));
}

export function sanitizeLookupTraceId(value: string | null | undefined): string | null {
  if (!value) return null;
  const trimmed = value.trim();
  if (!trimmed) return null;

  return /^[a-zA-Z0-9_-]{8,80}$/.test(trimmed) ? trimmed : null;
}
